module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "page-content"
    }
  }, [_c('div', {
    staticStyle: {
      "background": "url('static/images/l.jpg') no-repeat center center",
      "background-size": "cover"
    },
    attrs: {
      "id": "log-in"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    attrs: {
      "id": "register"
    }
  }, [_c('h1', [_vm._v("Sign Up!")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.buyerRegister($event)
      }
    }
  }, [_c('h3', [_vm._v("Account Information")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Full name")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "name": "name",
      "id": "name",
      "placeholder": "Full name"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "username"
    }
  }, [_vm._v("Username")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "name": "username",
      "id": "username",
      "placeholder": "username"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "name": "email",
      "id": "email",
      "placeholder": "email"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Password")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "password",
      "name": "password",
      "id": "password",
      "placeholder": "password"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "password_confirm"
    }
  }, [_vm._v("Confirm Password")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "password",
      "name": "password_confirm",
      "id": "password_confirm",
      "placeholder": "Confirm Password"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "mobile_number"
    }
  }, [_vm._v("Mobile Number")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "name": "mobile_number",
      "id": "mobile_number",
      "placeholder": "Mobile Number"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "token"
    },
    domProps: {
      "value": _vm.token
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Register")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px 0"
    },
    attrs: {
      "id": "message"
    }
  })])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-8",
    attrs: {
      "id": "supplierinfo"
    }
  }, [_c('h1', [_vm._v("Buyer Registration")]), _vm._v(" "), _c('p', [_vm._v("this template currently applies for buyers")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Buy Apollo lighting fixture products")]), _vm._v(" "), _c('li', [_vm._v("Get notifications reports about the products")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a004291a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Buyer.vue
// module id = 162
// module chunks = 0